<div>
  <div id="attractorLoopOem" class="live_preview d-flex">
    <div id="Comments" *ngIf='comments' class="comment">
      <div id="reviewerCommentBox" class="mb-3 text-left">
        <img class="chat_quote" alt="provide comments" />
        <span i18n="@@create-attractor-loop-oem.title.review-comment">Reviewer Comments</span>
      </div>
      {{comments}}
    </div>
    <div id="videoPreviewMain" class="video_preview_main">
      <div class="video_preview_part">
        <div id="videoPreview" class="video-preview" *ngIf='!isVideo; else videoBlock'>
          <div id="videoPreviewImg">
            <img src="assets/images/video-icon-lg.png" alt="preview" />
          </div>
          <div id="uploadVideoText">
            <span class="video-preview-label" i18n="@@create-attractor-loop-oem.video.preview-label">Upload a video to
              play during the Attract Loop.</span>
          </div>
        </div>
        <ng-template #videoBlock>
          <video [src]="videoUrls[selectedTabIndex]" controls></video>
        </ng-template>
      </div>
    </div>
  </div>
  <ul role="tablist" class="nav nav-tabs">
    <li class="nav-item">
      <a data-toggle="tab" class="nav-link active"><span
          i18n="@@create-attractor-loop-oem.title.new-attract-loop-video">NEW ATTRACT LOOP VIDEO</span></a>
    </li>
    <li class="nav-item exit_preview">
      <div class="nav-link">
        <img (click)='onCancle()' src="assets/images/exit_icon.svg" alt="exit without changes" />
      </div>
    </li>
  </ul>
  <div id="newLogoContent" class="tab-pane inActive">
    <div class="tab-content" id="newPromoTabs-content">
      <div>
        <div class="row">
          <div class="col-lg-3 container-decoration">
            <div id="systemIdSection">
              <span i18n="@@create-attractor-loop-oem.label.select-system-id">Select System ID</span>&nbsp;<span
                class="text-danger">*</span>
              <!-- <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" placement="top"
                [ngbPopover]="idpopUp" container="body" triggers="mouseenter:mouseleave" /> -->
            </div>
            <div id="systemIdBtn" class="mt-2">
              <button class="btn btn-primary" (click)='openPopup(systemIdPopup, this.selectedTabIndex)'><span
                  i18n="@@create-attractor-loop-oem.label.select-system-id">Select System ID</span></button>
              <div id="mainAfterPopupDisplay" *ngIf='mainAfterPopupDisplay.length' class="system-id-container mt-3 p-2">
                <ul>
                  <li *ngFor="let data of mainAfterPopupDisplay">
                    {{data[0]}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <!-- Tab div here -->
            <div id="tabContainer" class="tab-container">
            <ng-container *ngFor="let tab of tabs; let i = index">
              <div class="tab" [ngClass]="selectedTabIndex === i ? 'active-tab':'inactive-tab'"
                (click)="selectTab(i,true)">
                 <span id="Video1"  class="truncate-text" 
                 [attr.data-tooltip]="tab?.name || ('Video' + (i+1))">{{ (tab?.name || ('Video' + (i+1))) | slice:0:10 }}{{(tab?.name?.length > 10 ? '...' : '')}}</span>

                <span *ngIf="i === selectedTabIndex && tabs.length > 1" (click)="removeTab(i,$event)" class="video_crossmark" alt="video cross symbol"></span>               
              </div>
            </ng-container>
            <!-- Add video button -->
            <div class="add-video-main" [ngClass]="tabs.length >= maxTabs ? 'add-video-main-space':''">
              <div (click)="!isAddMoreDisabled && addTab()" *ngIf="tabs.length < maxTabs" class="tab add-video" [ngClass]="{'disabled': isAddMoreDisabled}"
              [ngbPopover]="isAddMoreDisabled ? addmoreTabDisabled : null" placement="right" triggers="mouseenter:mouseleave">
                <span i18n="@@create-attractor-loop-oem.new-attract-loop-video.add-more"><img class="video_add_mark" [ngClass]="{'video_add_mark_disable': isAddMoreDisabled}"
                    alt="plus_video">Add more</span>
              </div>
            </div>
            <ng-template #addmoreTabDisabled>
              <div class="popover-upload-req">
                <div class="d-flex align-items-center">
                  <span i18n="@@create-attractor-loop-oem.addmore-tab-disable-tooltip">Attract Loop Video already exists for all locations. Unselect one or more locations to add new attract loop video</span>
                </div>
              </div>
            </ng-template>
          </div>
          <ng-container *ngFor="let tab of tabs; let i = index">
            <div class="row d-flex" *ngIf="selectedTabIndex === i">
              <div class="col-lg-4 container-decoration">
                <div id="nameFieldLabel">
                  <span i18n="@@create-attractor-loop-oem.new-attract-loop-video.name">{{textLable}}</span>&nbsp;<span class="text-danger">*</span>
                </div>
                <div id="nameFieldInput" class="mt-2">
                  <input #name id="nameField" 
                  [ngClass]="{'err_border' : isNameError || isFieldRequired}"
                  [ngModel]="tabs[selectedTabIndex]?.name"
                  (ngModelChange)="checkNameInput($event, selectedTabIndex)"
                  [disabled]='!mainAfterPopupDisplay.length'
                  class="form-control" 
                  type="text" 
                  [placeholder]="textLable">
                  <em *ngIf='isNameError || isFieldRequired' class="err_icon_highlight"></em>
                </div>
                <div id="nameError" *ngIf='isNameError' class="text-danger">
                  <span i18n="@@create-attractor-loop-oem.validation-msg.name-exists">Name already exists</span>
                </div>
                <div id="nameRequired" *ngIf='isFieldRequired' class="text-danger">
                  <span i18n="@@create-attractor-loop-oem.validation-msg.name-exists">Name should not be Empty</span>
                </div>
          
            <div class="mt-4">
              <div id="popContent" class="form-group">
                <ng-template #popContent>
                  <div id="popoverUpload" class="popover-upload-req">
                    <div id="popOverVideoIcon" class="d-flex align-items-center">
                      <img src="assets/images/video-icon.png" alt="video" />
                      <ul>
                        <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format</li>
                        <li i18n="@@global.tooltip.video-rule-length-oem">Allowed maximum length is <strong>180
                            seconds</strong></li>
                        <li i18n="@@global.tooltip.video-max-size-error-oem">Allowed maximum size is <strong>30 MB</strong>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ng-template>
                <ng-template #idpopUp>
                  <div class="popover-upload-req">
                    <div id="creatorAttractSystemId" class="d-flex align-items-center">
                      <span i18n="@@create-attractor-loop-oem.popup-desc.system-id">The System ID determines which of
                        your devices this content will appear on.</span>
                    </div>
                  </div>
                </ng-template>
                <ng-template #locationidpopUp>
                  <div class="popover-upload-req">
                    <div id="videoLocation" class="d-flex align-items-center">
                      <span i18n="@@create-attractor-loop-oem.video-location.choose-locations">Choose the locations in
                        which the video
                        should be shown.</span>
                    </div>
                  </div>
                </ng-template>
                <label><span i18n="@@create-attractor-loop-oem.attract-loop-video.label">Attract Loop
                    Video</span>&nbsp;<span class="text-danger">*</span>
                  <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" placement="left"
                    [ngbPopover]="popContent" container="body" triggers="mouseenter:mouseleave" />
                </label>
                <div id="uploadButton">
                  <div id="videoInput" for="uploadedVideoName">
                    <input accept="video/mp4" #videoInput class="form-control" (change)='onVideoUpload($event, i)'
                      type="file" hidden />
                    <button [disabled]='!mainAfterPopupDisplay.length' (click)='videoInput.click()'
                      class="btn btn-primary left_icon_btn">
                      <span class="upload-video_icon"></span>
                      <span i18n="@@create-attractor-loop-oem.upload-video.label">Upload Video</span>
                    </button>
                  </div>
                  <div id="videoFileName" *ngIf='isVideoTriggered' class="file-name-container mt-1">
                    {{ isVideo ? tab?.fileName: '' }}
                  </div>
                  <div id="editModeFileName" *ngIf='!isVideoTriggered' class="file-name-container mt-1">
                    {{tab?.fileName}}
                  </div>
                  <div id="fileTypeError" *ngIf='fileTypeError' class="uploadfile_err_msg">
                    <span i18n="@@create-attractor-loop-oem.videoTypeError.incorrect">Incorrect file type
                      received.</span>
                    <div id="fileTypeErrorText">
                      <span i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong>
                        format.</span>
                    </div>
                  </div>
                  <div id="videoLengthError" *ngIf='videoLengthError' class="uploadfile_err_msg">
                    <span>{{attractLoopVideoErrorLengthMessage}}</span>
                  </div>
                  <div id="videoSizeError" *ngIf='videoSizeError' class="uploadfile_err_msg">
                    <span>{{attractLoopVideoErrorSizeMessage}}</span>
                  </div>
                  <div id="videoSizeError" *ngIf='isFileError' class="uploadfile_err_msg">
                    <span i18n="@@create-attractor-loop-oem.new-attract-loop-video.video-not-uploaded">Video is not uploaded</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="addLocation" class="col-lg-4 container-decoration">
            <div id="addLocationIcon">
              <span i18n="@@create-attractor-loop-oem.add-location.add-locations">Add Location</span>&nbsp;<span class="text-danger">*</span>
              <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" placement="top"
                [ngbPopover]="locationidpopUp" container="body" triggers="mouseenter:mouseleave" />
            </div>
            <div id="selectLocationBtn" class="mt-2">
              <button class="btn btn-primary" [disabled]='!mainAfterPopupDisplay.length' (click)='openPopup(locationPopup, selectedTabIndex)'><span
                  i18n="@@create-attractor-loop-oem.select-location-btn.select-from-list">Select from the
                  list</span></button>
            </div>
            <div id="locationListHeading" class="mt-1 mb-2">
              <span i18n="@@create-attractor-loop-oem.location-list-heading.locations-all">Locations: 
                <span *ngIf="tabs[selectedTabIndex].selectedLocations.length ? (tabs[selectedTabIndex].selectedLocations.length === maxAllCountries) && !clearLocation ? true : false : (selectAllCountries === maxAllCountries) && !clearLocation && (selectAllCountries === countryCount) ? true : false">All</span>
               </span>
              </div>
            <div id="locationList" class="list-box" *ngIf="tabs[selectedTabIndex].selectedLocations.length !== 0">
              <ul id="selectedLocations" class="selection-list">
                <li *ngFor="let location of tabs[selectedTabIndex].selectedLocations">{{ location | translateLocation}}</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4 ">
            <div id="publishDateTimeSec" class="form-group">
              <label for="publishedTimeStamp"><span i18n="@@create-logo-content.tab-pane.publish-date-time">Publishing
                  Date and Time</span></label>
              <div id="publishDate" class="publishDate-Section">
                <div id="publishDateInput">
                  <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                    [checked]="!tab.isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now', i)" [disabled]='!mainAfterPopupDisplay.length' />
                  <label for="now"><span i18n="@@create-logo-content.tab-pane.now">Now</span></label>
                </div>
                <div  id="customPublishDate" class="custom-datepicker" [ngClass]="tab.isPublishDateCustomDatepicker ? 'align-baseline' : ''">
                  <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
                    id="publish-date-custom" [checked]="tab.isPublishDateCustomDatepicker"
                    (click)="selectCustomPublishDate('custom', i)" [disabled]='!mainAfterPopupDisplay.length'/>
                  <label for="publish-date-custom" *ngIf="!tab.isPublishDateCustomDatepicker"><span
                      i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
                  <div *ngIf="tab.isPublishDateCustomDatepicker">
                    <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish', i)"
                      (getDateTimeZoneData)="getLogoContentPublishDate($event,i)"  (isTimeZoneSelected)="checkTimeZone($event,'publish', i)" 
                      [publishDateInfo]="tab.editPublishDateInfo" [divideDate]="divideDateFormat">
                    </iposcen-date-time-zone>
                  </div>
                </div>
                <div id="customPublishDateError" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected"
                  class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.publish-date-time-zone">Please
                    select publishing date and time
                    zone.</span>
                </div>
              </div>
            </div>
            <div id="expireDateSection" class="form-group">
              <label for="publishedTimeStamp"><span i18n="@@create-logo-content.tab-pane.expiry-date-time">Expiration
                  Date and Time</span></label>
              <div id="expireDateInput" class="publishDate-Section">
                <div>
                  <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                    [checked]="!tab.isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never',i)" [disabled]='!mainAfterPopupDisplay.length' />
                  <label for="never"><span i18n="@@create-logo-content.tab-pane.never">Never</span></label>
                </div>
                <div id="customExpireDate" class="custom-datepicker" [ngClass]="tab.isExpiryDatePicker ? 'align-baseline' : ''">
                  <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
                    [checked]="tab.isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom', i)" [disabled]='!mainAfterPopupDisplay.length' />
                  <label for="expiry-custom" *ngIf="!tab.isExpiryDatePicker"><span
                      i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
                  <div *ngIf="tab.isExpiryDatePicker">
                    <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry', i)"
                      (getDateTimeZoneData)="getLogoContentExpiryDate($event, i)" (isTimeZoneSelected)="checkTimeZone($event,'expiry', i)" 
                      [expiryDateInfo]="tab.editExpiryDateInfo" [divideDate]="divideDateFormat">
                    </iposcen-date-time-zone>
                  </div>
                </div>
                <div id="IncorrectExpireDate" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"><span
                    i18n="@@create-logo-content.tab-pane.expiry-less-than-publish-date">Expiration date should not be
                    before publishing date.</span>
                </div>
                <div id="NullexpireDateError" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected"
                  class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-date-and-time-zone">Please
                    select expiration date and
                    time zone.</span>
                </div>
              </div>
            </div>
          </div>
          <!--IIT3-33-->
        </div>
            </ng-container>                 
          </div>
        </div>
      </div>
      <div id="createAttractorBtnWrapper" class="button-wrapper" style="justify-content: flex-end">
        <button type="button" (click)='onCancle()' class="btn btn-outline-primary gtmCancelUpldVdo">
          <span i18n="@@create-attractor-loop-oem.newLogoContent.cancel">Cancel</span>
        </button>
        <button [disabled]='!isVideo || isSaveDisable()' (click)='onSaveClick()' type="button"
          class="btn btn-primary gtmSaveUpldVdo">
          <span i18n="@@create-attractor-loop-oem.newLogoContent.save">Save</span>
        </button>
      </div>
    </div>
    <!-- popups  -->
    <ng-template #systemIdPopup let-modal>
      <div id="systemIdPopupCard" class="card confirmPopup">
        <div id="systemIdModalHeader" class="modal-header">
          <div id="systemIdCloseIcon" (click)="onPopupCancel();modal.close()" class="close-icon">
            <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
          </div>
        </div>
        <div id="systemIdTitle" class="Title">
          <h2><span i18n="@@create-attractor-loop-oem.title.select-systemids">Select System IDs</span></h2>
          <div id="systemIdDisplay" class="mt-2"><span i18n="@@create-attractor-loop-oem.systemids.pagination">Showing
              <strong>{{displayData.length?showFrom:0}} - {{displayData.length?showTo:0}} of
                {{displayData.length}} System IDs</strong></span></div>
        </div>
        <div class="modal-body popup-body">
          <div>
            <div class="card-desc">
              <!-- search  -->
              <div id="systemIdSearchInput" class="mb-2 d-flex search-container">
                <input type="text" (ngModelChange)="$event ==='' && clearSearch()" id="partnerContentSearch"
                  [placeholder]="oemConst.SEARCH_SYSTEM_IDS" (ngModelChange)="searchData === '' ? resetData():true"
                  class="form-control mr-2" #search [(ngModel)]="searchData" (keyup.enter)="searchIds(searchData)" />
                <img class="search-clear-icon" alt="close" *ngIf="searchData?.length" (click)="clearSearch()" />

                <button type="button" class="btn mr-5 btn-primary search_btn gtmPartnerContentSearch"
                  (click)="searchIds(searchData)">
                  <img class="search_icon" alt="search" />
                </button>
              </div>
              <!-- select all  -->
              <div id="systemIdSelectAllCheckbox" class="mb-4 mt-3 data-container">
                <input class="mr-2" type="checkbox" [disabled]='selectAllDisable'
                  [checked]='isAllValidDataSelected && !selectAllDisable' [disabled]='!displayData.length'
                  (change)='selectAll($event.target.checked)'>
                <span>{{isAllValidDataSelected && !selectAllDisable ? oemConst.DESELECT:oemConst.SELECT}}</span>
              </div>
              <!-- checkbox  -->
              <div class="checkbox-container">
                <div id="systemIdCheckbox" class="mb-3 data-container"
                  *ngFor='let data of displayData | slice: (page-1) * tableSize : page * tableSize'>
                  <input type="checkbox" (change)='selectSystemId(data)'
                    [checked]='selectedIds.has(data[0]) || data[1][0]' [disabled]='data[1][0]' [ngClass]="data[1][0] ? 'locationUncheck': ''">
                  <span>{{data[0]}}</span>
                </div>
              </div>
              <div id="systemIdPagination" class="mt-3 d-flex justify-content-center">
                <ngb-pagination [collectionSize]="displayData.length" [(page)]="page" [pageSize]="tableSize"
                  [rotate]="false" [maxSize]="3" [ellipses]="true" [boundaryLinks]="false"
                  (pageChange)="onTableDataChange($event)">
                </ngb-pagination>
              </div>
              <div id="selectedSystemId" class="mt-1 d-flex justify-content-center">
                <span i18n="@@create-attractor-loop-oem.systemids.selected-text">{{selectedIds.size}} System ID
                  selected</span>
              </div>
            </div>
          </div>
        </div>
        <div id="systemIdModalFooter" class="modal-footer card-footer">
          <button type="button" (click)="onPopupCancel();modal.close()" class="btn btn-outline-primary btn-confirm">
            <span i18n="@@create-attractor-loop.newLogoContent.cancel">Cancel</span>
          </button>
          <button type="button" [disabled]='!selectedIds.size' (click)="onSaveSystemIds();modal.close()"
            class="btn btn-primary btn-confirm">
            <span i18n="@@create-attractor-loop-oem.systemids.applytosystemids-btn">Apply to System IDs</span>
          </button>
        </div>
      </div>
    </ng-template>
    <ng-template #systIDError let-modal>
      <div id="systIdPopupCard" class="card confirmPopup">
        <div id="systIdModalHeader" class="modal-header">
          <div id="systIdModalCloseIcon" (click)="onCancle();modal.close()" class="close-icon">
            <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
          </div>
        </div>
        <div id="systemIdModalBody" class="modal-body popup-body">
          <span i18n="@@create-attractor-loop-oem.popupBody.systemID-already">All the System IDs already have Attract
            Loop Videos. Please edit the choice of System IDs for existing Attract
            Loop Videos to create a new one.</span>
        </div>
      </div>
    </ng-template>
    <!--IIT3-33 Selection of Location Popup-->
    <ng-template #locationPopup let-modal>
      <div id="locationPopupCard" class="card locationPopup">
        <div id="locationModalHeader" class="modal-header">
          <div id="loationPopupCloseIcon" (click)="onPopupCancel();onCancelCountries();modal.close()" class="close-icon">
            <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
          </div>
        </div>
        <div id="locationTitle" class="Title">
          <h2><span i18n="@@create-attractor-loop-oem.location-title.choose-locations-to-show">Choose locations in which
              Attract Loop Video should be shown.</span></h2>
        </div>
        <div id="locationModalBody" class="modal-body popup-body">
          <div id="locationBodyNote">
            <span i18n="@@create-attractor-loop-oem.location-bofy-note.device-locations"><strong>Note: </strong>The
              device location is selected manually during installation of IPOS</span>
          </div>
          <div id="locationcheckbox" class="mt-3 location-container">
            <input class="mr-2" type="checkbox" [disabled]='checkotherTabsLocationUnknown()' [checked]="showLocationUnknown" (change)="onLocationUnknownChange($event)">
            <span [ngClass]="{'faded_text': checkotherTabsLocationUnknown()}" [ngbPopover]="checkotherTabsLocationUnknown() ? LocationUnknownPopover : null" placement="bottom-start" triggers="mouseenter:mouseleave" i18n="@@create-attractor-loop-oem.location-checkbox.show-video-unknown-locations">Show video if the location is unknown</span>
          </div>
          <ng-template #LocationUnknownPopover>
            <div class="popover-upload-req">
              <div class="d-flex align-items-center">
                <span i18n="@@create-attractor-loop-oem.new-attract-loop-video.location-unknown">Another video is already assigned when the location is unknown.</span>
              </div>
            </div>
          </ng-template>
        </div>
        <div id="locationHeaderSection" class="loc-container row" cdkDropListGroup>
          <div id="locationHeading" class="col-12 box-align">
            <div> <span class="location-heading"
                i18n="@@create-attractor-loop-oem.location-heading.attractloop-video-will-be-shown">Attract Loop Video
                will be shown in these locations</span></div>
            <div id="location1" class="location1">
                <div class="selectallClear-container">
                  <div class="locationPopup-selectall-checkbox">
                    <input class="mr-2" type="checkbox" 
                    [checked]="!(selectAllCountries) && selectAllCheckbox ? false :
                    (selectAllCountries ===  countryCount) && !clearLocation ? true : false" (change)='selectAllLocation($event)'
                    [disabled]="!(selectAllCountries) && selectAllCheckbox">
                    <span i18n="@@create-attractor-loop-oem.newLocation.selectall">Select All</span>
                  </div>
                  <div class="locationPopup-clearselection-button">
                    <button type="button" (click)='onClearLocationSelection()' class="btn btn-outline-primary gtmCancelUpldVdo">
                      <span i18n="@@create-attractor-loop-oem.newLocation.clearselection">Clear selection</span>
                    </button>
                  </div>
                </div>
              <div id="locationDropList" class="list-container">
                <ul id="list1" class="list-padding">
                    <li *ngFor="let displayCountry of (displayCountryFirstLetter | keyvalue)">
                      <div><strong>{{displayCountry.key}}</strong></div>
                      <div *ngFor="let countriesValue of displayCountry.value" [ngbPopover]="(countriesValue.checked && isSaved) ? locationDisabledpopUp : null" 
                      placement="right" triggers="mouseenter:mouseleave">
                            <span><input class="mr-2" type="checkbox" [checked]='countriesValue.checked' 
                              [ngClass]="countriesValue.checked && countriesValue.tabLocations !== selectedTabIndex && countriesValue.tabLocations !== -1 ? 'locationUncheck': ''" 
                              [disabled]='countriesValue.tabLocations !== selectedTabIndex && countriesValue.tabLocations !== -1'
                              (change)="selectedCountry(countriesValue, $event)"></span>{{countriesValue.item}}
                      </div>
                      <ng-template #locationDisabledpopUp>
                        <div class="popover-upload-req">
                          <div class="d-flex align-items-center">
                            <span i18n="@@create-attractor-loop-oem.newLocation.popup-disable-tooltip">This country already has an attract loop video assigned to it.</span>
                          </div>
                        </div>
                      </ng-template>
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="locationModalFooter" class="modal-footer card-footer footer-loc">
          <button type="button" (click)="onCancelCountries();modal.close()" class="btn btn-outline-primary btn-confirm">
            <span i18n="@@attractor-loop-popup.cancel-message">Cancel</span>
          </button>
          <button type="button" (click)="onSaveCountriesPopup(selectedTabIndex);modal.close()"
            class="btn btn-primary btn-confirm">
            <span i18n="@@create-attractor-loop-oem.newLogoContent.save">Save</span>
          </button>
        </div>
      </div>
    </ng-template>
  </div>